export const thailandTutorPageURL = 'https://www.snapask.co.th/how-to-be-tutor';



// WEBPACK FOOTER //
// ./app/constants/externalLinks.js